import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './locales/en.json';
import bnTranslations from './locales/bn.json';

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: enTranslations },
        bn: { translation: bnTranslations }
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    },
    react: {
        useSuspense: false
    }
});

export default i18n;
